import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var printMq = '@media print';
  return {
    itemsList: {
      paddingTop: componentTheme.itemsListPadding
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      '> *': {
        flex: '0 1 100%',
        padding: componentTheme.itemPadding
      }
    },
    question: {
      backgroundColor: componentTheme.questionColor,
      border: "".concat(componentTheme.questionBorder, " solid ").concat(componentTheme.questionBorderColor)
    },
    answer: {
      paddingLeft: 0,
      minWidth: 0 /* https://css-tricks.com/flexbox-truncated-text/ for why this is needed */
    },
    divider: {
      padding: '0',
      flexShrink: '1.3',
      borderBottom: "".concat(componentTheme.dividerBorder, " solid ").concat(componentTheme.dividerBorderColor)
    },
    choicesList: _defineProperty({
      display: 'none'
    }, printMq, {
      display: 'block'
    })
  };
};
export default generateStyle;